<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
>
<div *ngIf="loading" style="color: white; font-size: 16px;">Loading...</div>
</ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Application Summary</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="content-header">
                <p>{{applicantFullName}}</p>
                <mat-divider></mat-divider>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-toolbar class="toolbar-header">
                <span>Applicants</span>
                <span class="example-spacer"></span>
                <button mat-icon-button class="example-icon" aria-label="view attachment">
                  <mat-icon>file_copy</mat-icon>
                </button>
                <button mat-icon-button class="example-icon" aria-label="download attachment">
                  <mat-icon>cloud_download</mat-icon>
                </button>
              </mat-toolbar>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 secondRow">
              <div class="form-content">
                <!--Personal Details-->
                <div>
                  <div class="summary-header">
                    <h4>Personal Details</h4>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12">
                      <div class="passport">
                        <!-- Passport Photo -->
                        <div class="passport-card">
                          <h6>Passport Photo</h6>
                          <img mat-card-image src="{{photolink}}" alt="Passport Photo">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-12">
                      <div class="summary-content">
                        <div class="row">
                          <!-- Title -->
                          <div class="col-lg-3 col-md-6 col-sm-12">
                            <mat-label>Title</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <mat-select [(ngModel)]="title" id="abstractCategory" required>
                                <mat-option *ngFor="let title of titleList" [value]="title">{{title.title}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <!-- Surname -->
                          <div class="col-lg-9 col-md-6 col-sm-12">
                            <mat-label>Surname</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <input matInput [(ngModel)]="surname">
                            </mat-form-field>
                          </div>
                          <!-- First Name -->
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <mat-label>First Name</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <input matInput [(ngModel)]="firstName">
                            </mat-form-field>
                          </div>
                          <!-- Middle Name -->
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <mat-label>Middle Name</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <input matInput [(ngModel)]="middleName">
                            </mat-form-field>
                          </div>
                          <!-- Other Names -->
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <mat-label>Other Names</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <input matInput matInput [(ngModel)]="otherName">
                            </mat-form-field>
                          </div>
                          <!-- Gender -->
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <mat-label>Gender</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <mat-select [(ngModel)]="gender" id="gender" required>
                                <mat-option *ngFor="let gender of genderList" [value]="gender"
                                  style="font-weight:bold;">
                                  {{gender.gender}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <!-- Date of Birth -->
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <mat-label>Date of Birth</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <input matInput [matDatepicker]="picker" [value]="dob">
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <!-- Country of Birth -->
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <mat-label>Country of Birth</mat-label>
                            <mat-form-field appearance="outline" color="accent" class="full-width">
                              <mat-select [(ngModel)]="countryOfBirth" id="countryOfBirth" required>
                                <mat-option *ngFor="let countryOfBirth of countryofBirthList" [value]="countryOfBirth"
                                  style="font-weight:bold;">{{countryOfBirth.country}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 ">
                      <div class="row mt-2">
                        <!-- City of Birth -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>City of Birth</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input matInput [(ngModel)]="placeOfBirth">
                          </mat-form-field>
                        </div>
                        <!-- Nationality -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Nationality</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <mat-select [(ngModel)]="nationality" id="nationalityId" required>
                              <mat-option *ngFor="let nationality of nationalityList" [value]="nationality"
                                style="font-weight:bold;">{{nationality.country}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Hometown -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Hometown</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input matInput [(ngModel)]="hometown">
                          </mat-form-field>
                        </div>
                        <!-- Region -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Region</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <mat-select [(ngModel)]="region" id="regionId" required>
                              <mat-option *ngFor="let region of regionList" [value]="region" style="font-weight:bold;">
                                {{region.region}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Religion -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Religion</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <mat-select [(ngModel)]="religion" id="religion" required>
                              <mat-option *ngFor="let religion of religionList" [value]="religion">
                                {{religion.religion}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Email -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Email</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input matInput type="email" [(ngModel)]="email">
                          </mat-form-field>
                        </div>
                        <!-- Telephone -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Mobile No</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input matInput type="tel" [(ngModel)]="mobileno">
                          </mat-form-field>
                        </div>
                        <!-- Do you have special needs? -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Special needs?</mat-label>
                          <mat-radio-group aria-label="Select an option" class="half-width" color="accent">
                            <br>
                            <span>
                              <mat-radio-group [(ngModel)]="specialNeeds">
                                <mat-radio-button [value]="'1'" name="specialNeeds" [checked]="specialNeeds === '1'">Yes
                                </mat-radio-button>
                                <mat-radio-button [value]="'0'" name="specialNeeds" [checked]="specialNeeds === '0'">No
                                </mat-radio-button>
                              </mat-radio-group>
                            </span>
                          </mat-radio-group>
                        </div>
                        <!-- If yes, please specify -->
                        <div class="col-lg-12 col-md-12 col-sm-12">
                          <mat-label>Special Needs Comments</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <textarea rows="5" matInput placeholder="Eg I am ...."
                              [(ngModel)]="specialNeedDetails"></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Contact Information-->
                <div>
                  <div class="summary-header">
                    <h4>Contact Information</h4>
                  </div>
                  <div class="mt-3">
                    <h5>Postal Address</h5>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 ">
                      <div class="row mt-2">
                        <!-- Address -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Address 1</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="postalAddress1" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Address -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Address 2</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="postalAddress2" matInput>
                          </mat-form-field>
                        </div>
                        <!-- City/Town -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>City/Town</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="postalCityTown" matInput>
                          </mat-form-field>
                        </div>
                        <!-- State -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>State</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="postalState" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Nationality -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Nationality</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <mat-select [(ngModel)]="postalAddressNationality" required>
                              <mat-option *ngFor="let nationality of nationalityList" [value]="nationality"
                                style="font-weight:bold;">{{nationality.country}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Postal Code -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Postal Code</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="postalPostcode" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Telephone -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Telephone</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="mobileno" matInput>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h5>Permanent Address</h5>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 ">
                      <div class="row mt-2">
                        <!-- Address -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Address 1</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="permanentAddress1" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Address -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Address 2</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="permanentAddress2" matInput>
                          </mat-form-field>
                        </div>
                        <!-- City/Town -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>City/Town</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="permanentCityTown" matInput>
                          </mat-form-field>
                        </div>
                        <!-- State -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>State</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="permanentState" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Nationality -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Nationality</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <mat-select [(ngModel)]="permanentAddressNationality" required>
                              <mat-option *ngFor="let nationality of nationalityList" [value]="nationality"
                                style="font-weight:bold;">{{nationality.country}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Postal Code -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Postal Code</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="permanentPostcode" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Telephone -->
                        <div class="col-lg-6 col-md-6 col-sm-12">
                          <mat-label>Telephone</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="phoneno" matInput>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Particulars of Parent/Guardian/Sponsor-->
                <div class="summary-header">
                  <h4>Particulars of Parent/Guardian/Sponsor</h4>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 ">
                    <div class="row mt-2">
                      <!-- Title -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Title</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorTitle" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Address -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Surname</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorSurname" matInput>
                        </mat-form-field>
                      </div>
                      <!-- First Name -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>First Name</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorFirstName" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Middle Name -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Middle Name</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorMiddleName" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Relationship to Applicant -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Relationship to Applicant</mat-label>
                        <mat-radio-group aria-label="Select an option" class="half-width" color="accent">
                          <br>
                          <span>
                            <mat-radio-group [(ngModel)]="sponsorRelationship">
                              <mat-radio-button [value]="'PARENT'" name="relationship"
                                [checked]="sponsorRelationship==='PARENT'">Parent</mat-radio-button>
                              <mat-radio-button [value]="'GUARDIAN'" name="relationship"
                                [checked]="sponsorRelationship==='GUARDIAN'">Guardian</mat-radio-button>
                              <mat-radio-button [value]="'SPONSOR'" name="relationship"
                                [checked]="sponsorRelationship==='SPONSOR'">Sponsor</mat-radio-button>
                            </mat-radio-group>
                          </span>
                        </mat-radio-group>
                      </div>
                      <!-- Company (for institutions and corporate bodies sponsoring an applicant) -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Company (for institutions and corporate bodies sponsoring an applicant)</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorCompany" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Occupation -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Occupation</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorOccupation" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Address -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Address 1</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorAddress1" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Address -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Address 2</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorAddress2" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Country -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Country</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-select [(ngModel)]="sponsorCountry" required>
                            <mat-option *ngFor="let sponsorCountry of sponsorCountryList" [value]="sponsorCountry"
                              style="font-weight:bold;">{{sponsorCountry.country}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <!-- City/Town -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>City/Town</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorCity" matInput>
                        </mat-form-field>
                      </div>
                      <!-- State -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>State</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorState" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Mobile Number -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Mobile Number</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsormobileNo" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Telephone -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Telephone</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsortelephone" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Email Address -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Email Address</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorEmail" matInput>
                        </mat-form-field>
                      </div>
                      <!-- Postal Code -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-label>Postal Code</mat-label>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input [(ngModel)]="sponsorPostalcode" matInput>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Programme Selection-->
                <div>
                  <div class="summary-header">
                    <h4>Programme Selection</h4>
                  </div>
                  <div class="row mt-2">
                    <!-- Application Received Date: -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Application Received Date:</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input matInput [matDatepicker]="picker2" [value]="applicationRecievedDate">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <!-- Registration No. -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Registration Number:</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input matInput [(ngModel)]="applicationNo">
                      </mat-form-field>
                    </div>
                    <!-- Programme Type -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Programme Type</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <mat-select [(ngModel)]="programmeType">
                          <mat-option *ngFor="let programmeType of programmeTypeList" [value]="programmeType">
                            {{programmeType.programmeType}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>                  
                    <!-- Semester Registration -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Semester</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <mat-select [(ngModel)]="selectedSemester" placeholder="Select Semester">
                          <mat-option [value]="'1'">Semester 1</mat-option>
                          <mat-option [value]="'2'">Semester 2</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!--Educational Background-->
                <div>
                  <div class="summary-header">
                    <h4>Educational Background</h4>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Current or most recent SHS/Institution</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="institution" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>City/Town</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="educationalBackgroundCityName" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Country</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="educationalBackgroundCountryName" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Year of Entry</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="educationBackgroundStartDate" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Year of Completion</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="educationBackgroundCompleteDate" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Qualification</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="educationBackgroundQualification" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>If Others, enter Qualification here</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="educationBackgroundotherQualification" matInput>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div *ngIf="enrolled === '1'">
                  <div class="summary-header">
                    <h4>Previous Attendance at a University/College</h4>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Name of University/College</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="previousAttendanceCollegeName" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Full name used at the University/College</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="previousAttendanceFullName" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Date of Admission</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="previousAttendanceAdmissionDate" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Hall/Hostel of residence (if applicable)</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="previousAttendanceHostel" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Programme of Study</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="previousAttendanceProgramme" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Last Year of Study</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="previousAttendanceLastYearOfStudy" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <mat-label>Reason(s) for Leaving the University/College</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <textarea rows="5" matInput [(ngModel)]="previousAttendanceReasonOfLeaving"
                          placeholder="Please enter your text here"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!--Examinations Taken-->
                <div>
                  <div class="summary-header">
                    <h4>Examinations Taken</h4>
                  </div>
                  <div>
                    <table mat-table [dataSource]="examinationTakenList" class="mat-elevation-z8 mt-2">

                      <!--- Note that these columns can be defined in any order.
                            The actual rendered columns are set as a property on the row definition" -->

                      <!-- Examination ID Column -->
                      <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef> ID. </th>
                        <td mat-cell *matCellDef="let element"> {{element.examinationId}} </td>
                      </ng-container>

                      <!-- Examination Type -->
                      <ng-container matColumnDef="ExamType">
                        <th mat-header-cell *matHeaderCellDef> Examination Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.certificate}} </td>
                      </ng-container>

                      <!-- Index Number -->
                      <ng-container matColumnDef="index_number">
                        <th mat-header-cell *matHeaderCellDef> Index Number </th>
                        <td mat-cell *matCellDef="let element"> {{element.examinationIndexNo}} </td>
                      </ng-container>

                      <!-- Examination Date -->
                      <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.examinationDate}} </td>
                      </ng-container>

                      <!-- Results slip -->
                      <ng-container matColumnDef="results_slip">
                        <th mat-header-cell *matHeaderCellDef> Results Slip</th>
                        <tr>
                          <td mat-cell *matCellDef="let element"> <a href="{{certificateLink}}"
                              target="_blank">{{element.results}}</a>
                          </td>
                        </tr>

                      </ng-container>

                      <!-- Certificate Name -->
                      <ng-container matColumnDef="certificate_name">
                        <th mat-header-cell *matHeaderCellDef> Certificate Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.certificate}} </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                </div>
                <!--Examination Subjects-->
                <div>
                  <div class="summary-header mt-3">
                    <h4>Examination Subjects</h4>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-12 col-md-12 col-sm-12"
                      *ngFor="let examinationsubjects of examinationsubjectsList;let i = index">
                      <div class="row" *ngFor="let subjectGrade of examinationsubjects.subjectGrades; let j = index;">
                        <!-- Subject 1 -->
                        <div class="col-lg-4 col-md-4 col-sm-4">
                          <mat-label>Subject</mat-label>
                          <mat-form-field appearance="outline" color="accent" class="full-width">
                            <input [(ngModel)]="subjectGrade.subject" [readonly]="j===0 || j===1" matInput>
                          </mat-form-field>
                        </div>
                        <!-- Grade 1 -->
                        <div class="col-lg-2 col-md-2 col-sm-2">
                          <mat-label>Grade</mat-label>
                          <mat-form-field appearance="outline" color="primary" class="full-width">
                            <input [(ngModel)]="subjectGrade.grade" matInput>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Portfolio Review-->
                <div>
                  <div class="summary-header">
                    <h4>Portfolio Review</h4>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12" *ngFor="let portfolio of portfolioList;let i = index">
                      <div class="portfolio">
                        <!-- Passport Photo -->
                        <div class="portfolio-card">
                          <h6>{{portfolio.portfolio}}</h6>
                          <img mat-card-image src="{{portfolio.attachmentUrl}}" alt="Portfolio Picture">
                        </div>
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <input name="portfolio{{i}}" [(ngModel)]="portfolio.portfolio" matInput>
                        </mat-form-field>
                      </div>
                    </div>

                  </div>
                </div>
                <!--Financing Your Study-->
                <div>
                  <div class="summary-header">
                    <h4>Financing Your Study</h4>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <mat-label>How do you intend to finance your study in AUCDT?</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="sponsorRelationship" name="relationship" matInput>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <mat-label>If others, please specify</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <textarea [(ngModel)]="others" matInput placeholder="Eg I am ...."></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!--Referee-->
                <div>
                  <div class="summary-header">
                    <h4>Referee</h4>
                  </div>
                  <div class="row mt-2">
                    <!-- Title -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Title</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="refreetitle" name="refreetitle" matInput>
                      </mat-form-field>
                    </div>
                    <!-- Position -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Position</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="refreeposition" name="refreeposition" matInput>
                      </mat-form-field>
                    </div>
                    <!-- Full Name -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Full Name</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="refreefullname" name="refreefullname" matInput>
                      </mat-form-field>
                    </div>
                    <!-- Email Address -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Email Address</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="refreeemailaddress" name="refreeemailaddress" matInput>
                      </mat-form-field>
                    </div>
                    <!-- Occupation -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Occupation</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="refreeoccupation" name="refreeoccupation" matInput>
                      </mat-form-field>
                    </div>
                    <!-- Date -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <mat-label>Date</mat-label>
                      <mat-form-field appearance="outline" color="accent" class="full-width">
                        <input [(ngModel)]="refreedate" name="refreedate" matInput>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <mat-divider></mat-divider>
                <div class="row mt-4">
                  <!-- Application Status -->
                  <div class="col-lg-12 col-md-12  col-sm-12">
                    <mat-label>Application Status</mat-label>
                    <mat-form-field appearance="outline" color="accent">
                      <mat-select [(ngModel)]="applicantStatus">
                        <mat-option *ngFor="let applicantStatus of applicantStatusList " [value]="applicantStatus">
                          {{applicantStatus}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div>
                  <button mat-raised-button class="update-button">
                    <a mat-button (click)="saveApplicantDetails()">Update</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>